/* ===== CATI Pakistan — Main Entry ===== */
import './css/variables.css';
import './css/base.css';
import './css/layout.css';
import './css/animations.css';
import './css/components.css';

import { initRenderer } from './js/renderer.js';
import { initNavigation } from './js/navigation.js';
import { initCarousel } from './js/carousel.js';
import { initCounters } from './js/counters.js';
import { initGallery } from './js/gallery.js';
import { initForms } from './js/forms.js';
import { initScrollReveal } from './js/scroll-reveal.js';
import { initGsapAnimations } from './js/gsap-animations.js';
import { initThemeSwitcher } from './js/theme-switcher.js';
import { trackPageView } from './js/analytics.js';

// Apply saved theme immediately before render to avoid flicker
try {
  const savedTheme = localStorage.getItem('cati_user_theme');
  if (savedTheme && savedTheme !== 'classic') {
    document.documentElement.setAttribute('data-user-theme', savedTheme);
  }
} catch (e) {}

document.addEventListener('DOMContentLoaded', () => {
  // Track visitor page view
  trackPageView();
  // Render dynamic content first
  initRenderer();
  // Then initialize interactive modules
  initNavigation();
  initCarousel();
  initCounters();
  initGallery();
  initForms();
  initScrollReveal();
  initGsapAnimations();
  initThemeSwitcher();
});
